import CollectionDeleteButton from "./collection-delete-button";

export default CollectionDeleteButton;